import React, { useState, useRef, useEffect, useCallback, useMemo } from 'react';
import moment from "moment";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate, useLocation, useParams, Link } from 'react-router-dom';
import "react-datepicker/dist/react-datepicker.css";
import { Tab, Nav, Modal, Button, Dropdown } from "react-bootstrap";
import './mention.css'
import { FiArrowLeft } from 'react-icons/fi';

import './taskdetails.css';
import '../forum/forum.css';
import CommentSection from './commentsection';
import axiosInstance from '../../services/AxiosInstance';
import TaskAttachmentImage from '../components/TaskAttachmentImage';
import { openTaskAttachmentInNewTab } from '../../utils/taskAttachment';
import '../Documents/commonstyle.css';
import Quill from 'quill';
import InternalFooter from '../components/InternalFooter/InternalFooter';
import BackToTop from '../components/BackToTop/BackToTop';
import { formatDateToDDMMMYYYY, formatDateTimeToDDMMMYYYY } from '../../utils/dateFormatter';
import ReadOnlyQuill from './ReadOnlyQuill';
import { getCommentIdFromLocation } from '../../utils/commentDeepLink';
import { isCorporateAdmin } from '../../utils/roleAccess';
import { useCanDo } from '../../hooks/useCanDo';
import { useCanAccessProjects } from '../../hooks/useCanAccessProjects';
import { navigateBackSafely as safeNavigateBack } from '../../utils/navigateBackSafely';
import { getReturnToFallback, withListQuery } from '../../utils/listQueryPersistence';
import {
  extractTimeFromDatetime,
  buildTaskDatetime,
  taskUsesSameDayTimes,
  toDateOnlyString,
  datetimeHasSpecificTime,
} from '../../utils/taskTime';
import { usePageToolbar } from '../layouts/nav/PageToolbarContext';


let userlist = []
const formatDate = (dateObj) => {
  if (!dateObj) return '';
  const date = new Date(dateObj);
  if (isNaN(date.getTime())) return '';
  const yyyy = date.getFullYear();
  const mm = String(date.getMonth() + 1).padStart(2, '0');
  const dd = String(date.getDate()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}`;
};

const TaskDetails = () => {
  const { taskid } = useParams();
  const location = useLocation();

  const taskListPath = '/task/tasklist';
  const taskListFallback = getReturnToFallback(
    location.search,
    withListQuery(taskListPath, location.search)
  );

  const navigateBackSafely = () => {
    safeNavigateBack(navigate, taskListFallback);
  };

  const [taskData, setTaskData] = useState({
    title: '', // Updated from TaskName
    parent_task: '', // Updated from ParentTaskId
    project_id: '', // Updated from ProjectId
    description: '', // Updated from Description
    delta: '', // Updated from Delta
    mentions: [], // Updated from Mentions
    allow_shortcut: false, // Updated from AllowShortCut
    priority: '', // Updated from Priority
    status: '', // Updated from Status
    start_date: formatDate(new Date()), // Updated from StartDate
    due_date: formatDate(new Date()), // Updated from Deadline
    start_time: '12:00 PM', // Time for start date
    end_time: '12:00 PM', // Time for end date
    repeate_type: '', // Updated from RepeatType
    repeat_interval: '', // Updated from RepeatInterval
    repeat_until: formatDate(new Date()), // Updated from RepeatUntil
    is_repeatable: false, // Added for repeat task indicator
    repeated_from_task_id: null, // Added for repeat task instance indicator
    allow_assignee_update: false, // Updated from AllowAssigneeUpdate
    send_warning: false, // Updated from SendWarning
    close_checklist: false, // Updated from CloseChecklist
    created_by: '', // Updated from CreatedBy
    created_by_name: '', // Updated from CreatedByName
    created_at: '', // Added for sidebar display and typing consistency
    assignee_list: [], // Updated from assigneeList
    email: '',
    reminder_email: '',
    task_status_email: '',
    tags: [],
    files: [],
    reminder_internal_message: true,
    reminder_through_email: false,
    mark_high_priority: false,
    task_pin: false,
    participants: [],
    observers: []
  });
  const [checklists, setChecklists] = useState([
    { title: 'Checklist #1', items: [''] },
  ]);
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [availableAssignees, setAvailableAssignees] = useState([])
  const [Tags, setTags] = useState([])
  const [observers, setObservers] = useState([])
  const [participants, setParticipants] = useState([])
  const [userdata, setuserdata] = useState()
  const [fields, setFields] = useState([
    { value: '', isEditing: true, checked: false },
  ]);
  const [statusChange, setStatusChange] = useState('START')
  const [oldTaskData, setOldTaskData] = useState([])
  const navigate = useNavigate();
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);

  const [Tasks, setTasks] = useState([])
  const [Mentions, setMentions] = useState([])

  // Standardized status mapping
  const returnStatusMap = {
    0: 'Pending',
    1: 'In Progress',
    2: 'Blocked',
    3: 'Completed',
    4: 'Paused',
    5: 'Partial'
  };

  const statusMap = {
    'Pending': 0,
    'In Progress': 1,
    'Blocked': 2,
    'Completed': 3,
    'Paused': 4,
    'Partial': 5
  };
  const [filePreview, setFilePreview] = useState(null);
  const [showPreviewModal, setShowPreviewModal] = useState(false);
  const fileInputRef = useRef(null); // Create a ref for the file input 
  const [error, setError] = useState({});
  const checklist = fields.map((field, index) => ({
    ChecklistItem: field.value,
    IsCompleted: field.checked,
    SortOrder: index + 1
  }));
  const [value, setValue] = useState('');
  const [comments, setComments] = useState([])
  const [delta, setDelta] = useState()
  const [Description, setDescription] = useState()
  const [loading, setLoading] = useState(true);
  const [statusChangeLoading, setStatusChangeLoading] = useState(false);
  const [History, setHistory] = useState([])
  const [changedFields, setChangedFields] = useState(['Checklist added'])
  const [reminder, setReminder] = useState(false);
  const [taskStatus, setTaskStatus] = useState("-1")
  const [individualProgress, setIndividualProgress] = useState(null);
  const [createAsIndividual, setCreateAsIndividual] = useState(false);
  const [activeTab, setActiveTab] = useState('comments');
  const [infoOpen, setInfoOpen] = useState(false);

  // Display subject: use subject if present, else first line or first 10 words from content (display only)
  const getDisplaySubject = (subject, content) => {
    if (subject && String(subject).trim()) return String(subject).trim();
    const plain = (content || '').replace(/<[^>]+>/g, ' ').replace(/&nbsp;/gi, ' ').replace(/\s+/g, ' ').trim();
    const firstLine = plain.split(/\n/)[0] || plain;
    const words = firstLine.split(/\s+/).filter(Boolean).slice(0, 10).join(' ');
    return words || '(No subject)';
  };

  // Helper function to get current user's effective status (individual or task status)
  const getCurrentUserStatus = useMemo(() => {
    // If task is create_as_individual, check for current user's individual progress
    if (createAsIndividual && individualProgress && individualProgress.all_progress && userdata) {
      // Try to find current user's progress by matching user_id, corporate_user_id, or email
      const currentUserProgress = individualProgress.all_progress.find(progress => {
        return (
          progress.user_id === userdata.id ||
          progress.corporate_user_id === userdata.id ||
          progress.corporateUserId === userdata.id ||
          progress.user_email === userdata.email ||
          progress.email === userdata.email
        );
      });
      
      // If current user has individual progress, return their status
      if (currentUserProgress !== undefined && currentUserProgress.status !== undefined && currentUserProgress.status !== null) {
        return String(currentUserProgress.status);
      }
    }
    // Otherwise, return the actual task status
    return taskStatus;
  }, [createAsIndividual, individualProgress, userdata, taskStatus]);

  const taskStatusMaper = {
    "-1": "Overdue",
    "0": "Pending",
    "1": "In Progress",
    "2": "Blocked",
    "3": "Completed",
    "4": "Paused",
    "5": "Partial"
  }

  /** Red banner above the sidebar — must match effective status, not only start date. */
  const statusBoxTitle = useMemo(() => {
    const startDate = formatDateToDDMMMYYYY(taskData.start_date);
    const start = taskData.start_date ? new Date(taskData.start_date) : null;
    const today = new Date(new Date().toDateString());
    if (start && start > today) {
      return `Starts from ${startDate}`;
    }
    switch (getCurrentUserStatus) {
      case '3':
        return taskData.completed_at
          ? `Completed on ${formatDateToDDMMMYYYY(taskData.completed_at)}`
          : 'Completed';
      case '-1':
        return taskData.end_date
          ? `Overdue since ${formatDateToDDMMMYYYY(taskData.end_date)}`
          : 'Overdue';
      case '1':
        return `In progress since ${startDate}`;
      case '2':
        return 'Blocked';
      case '4':
        return 'Paused';
      case '5':
        return 'Partial';
      case '0':
      default:
        return `Pending since ${startDate}`;
    }
  }, [getCurrentUserStatus, taskData.start_date, taskData.end_date, taskData.completed_at]);

  /**
   * Generates a clear, human-readable message for each task history entry.
   * Handles both hardcoded (assignees, observers, checklist) and dynamic field types.
   */
  const getHistoryMessage = (item) => {
    const { field_changed, old_value, new_value } = item;
    const formatVal = (v) => (v === null || v === undefined || v === '') ? null : String(v).trim();
    const oldVal = formatVal(old_value);
    const newVal = formatVal(new_value);
    const getStatusLabel = (v) => returnStatusMap[parseInt(v)] ?? taskStatusMaper[String(v)] ?? v;

    // Hardcoded: assignees, observers, checklist - no specific values shown
    switch (field_changed) {
      case 'assignee_removed':
        return 'Removed an assignee';
      case 'assignee_added':
        return 'Added an assignee';
      case 'observer_removed':
        return 'Removed an observer';
      case 'observer_added':
        return 'Added an observer';
      case 'checklist_item_added':
        return 'Added a checklist item';
      case 'checklist_item_removed':
        return 'Removed a checklist item';
      case 'checklist_item_updated':
        return 'Updated a checklist item';
      case 'checklist_item_completion':
        return 'Updated checklist item completion';
      case 'individual_status':
        return 'Individual status updated';
      case 'status':
        return `Status changed from ${getStatusLabel(oldVal)} to ${getStatusLabel(newVal)}`;
      case 'description':
        return 'Description changed';
      case 'delta':
        return null; // Hidden - do not display
    }

    // Dynamic fields: human-readable labels and formatted values
    const fieldLabels = {
      title: 'Title',
      project_id: 'Project',
      priority: 'Priority',
      start_date: 'Start date',
      due_date: 'Due date',
      parent_task: 'Parent task',
      is_repeatable: 'Repeatable',
      repeate_type: 'Repeat type',
      repeat_interval: 'Repeat interval',
      repeat_week_days: 'Repeat week days',
      monthly_repeat_type: 'Monthly repeat type',
      repeat_until: 'Repeat until',
      repeat_never_ends: 'Repeat never ends',
      is_assignee_update_allowed: 'Assignee update allowed',
      email_reminder: 'Email reminder',
      create_as_individual: 'Create as individual'
    };

    const label = fieldLabels[field_changed] || field_changed?.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase()) || 'Field';

    // Only status shows old/new values; all other fields show label only
    return `${label} changed`;
  }

  // Maps field_changed to short label for compact display
  const getFieldLabel = (field_changed) => {
    const labelMap = {
      assignee_removed: 'Assignees', assignee_added: 'Assignees',
      observer_removed: 'Observers', observer_added: 'Observers',
      checklist_item_added: 'Checklist', checklist_item_removed: 'Checklist',
      checklist_item_updated: 'Checklist', checklist_item_completion: 'Checklist',
      individual_status: 'Individual status', status: 'Status', description: 'Description',
      title: 'Title', project_id: 'Project', priority: 'Priority',
      start_date: 'Start date', due_date: 'Due date', parent_task: 'Parent task',
      is_repeatable: 'Repeatable', repeate_type: 'Repeat type', repeat_interval: 'Repeat interval',
      repeat_week_days: 'Repeat week days', monthly_repeat_type: 'Monthly repeat type',
      repeat_until: 'Repeat until', repeat_never_ends: 'Repeat never ends',
      is_assignee_update_allowed: 'Assignee update allowed', email_reminder: 'Email reminder',
      create_as_individual: 'Create as individual'
    };
    return labelMap[field_changed] || field_changed?.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase()) || 'Field';
  };

  // Merge history entries by same user + same time (within 1 second)
  const mergedHistory = useMemo(() => {
    const filtered = (History || []).filter((item) => item.field_changed !== 'delta');
    if (!filtered.length) return [];

    const groups = new Map();
    for (const item of filtered) {
      const t = new Date(item.created_at).getTime();
      const rounded = Math.floor(t / 1000) * 1000;
      const key = `${item.changed_by}-${rounded}`;
      if (!groups.has(key)) {
        groups.set(key, { created_at: item.created_at, changed_by_user: item.changed_by_user, items: [] });
      }
      groups.get(key).items.push(item);
    }

    return Array.from(groups.values())
      .map((group) => {
        const messages = group.items.map((item) => getHistoryMessage(item)).filter(Boolean);
        const labels = [...new Set(group.items.map((item) => getFieldLabel(item.field_changed)))];
        const count = labels.length;

        let message;
        if (count === 1) {
          message = messages[0];
        } else if (count <= 3) {
          message = `${labels.join(', ')} were updated`;
        } else {
          const shown = labels.slice(0, 3).join(', ');
          message = `${shown}, etc. (${count} fields updated)`;
        }
        return { ...group, id: group.items[0].id, message };
      })
      .sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
  }, [History]);

  // Role checks for checklist disabling
  const isObserver = Array.isArray(taskData.observers) && taskData.observers.some(o => o.CorporateUserId === userdata?.id);
  const isCreator = userdata?.id === taskData.created_by;
  const isAssignee = Array.isArray(taskData.assignee_list) && taskData.assignee_list.some(a => a.CorporateUserId === userdata?.id);
  const isAssigneeScopeMatch =
    (Array.isArray(taskData.assignee_list) && taskData.assignee_list.some(a => a.CorporateUserId === userdata?.id)) ||
    (Array.isArray(taskData.departments) && taskData.departments.some(d => d.department_id === userdata?.departmentId && d.is_assignee == true)) ||
    (Array.isArray(taskData.branches) && taskData.branches.some(b => b.branch_id === userdata?.branchId && b.is_assignee == true));
  const showTaskStatusToolbar = userdata && (
    createAsIndividual ? isAssigneeScopeMatch : (userdata.id == taskData.created_by || isAssigneeScopeMatch)
  );
  const canEditTask = useCanDo('tasks', 'create_edit');
  const canDeleteTask = useCanDo('tasks', 'delete');
  const canExportTask = useCanDo('tasks', 'export');
  const { canAccessProjects } = useCanAccessProjects();
  const canManageThisTask = userdata && (
    userdata.id == taskData.created_by ||
    (taskData.is_assignee_update_allowed && isAssigneeScopeMatch)
  );
  const showEditToolbar = canManageThisTask && canEditTask;
  const showDeleteToolbar = canDeleteTask;
  const showEditDeleteToolbar = showEditToolbar || showDeleteToolbar;
  const showIndividualTaskStatusDisabledHint =
    createAsIndividual && userdata && !showTaskStatusToolbar;
  const individualTaskStatusHintMessage = showIndividualTaskStatusDisabledHint
    ? isObserver
      ? 'You are an observer on this task, Only assignees can start, pause, or change status from this page.'
      : isCreator
        ? 'This is an individual task: status controls on this page are only available to assignees. You can still edit or delete the task using the buttons below.'
        : 'This is an individual task. Only assignees can start, pause, or change status from this page.'
    : null;
  const showObserverNormalTaskHint =
    userdata &&
    !createAsIndividual &&
    isObserver &&
    !showTaskStatusToolbar &&
    !showEditDeleteToolbar;
  const observerNormalTaskHintMessage = showObserverNormalTaskHint
    ? 'You are an observer on this task, Only assignees can start, pause, or change status from this page.'
    : null;
  const disableCheckbox = isObserver && !isCreator && !(isAssignee && taskData.is_assignee_update_allowed);

  const taskStatusTransitionOptions = useMemo(() => {
    const s = getCurrentUserStatus;
    const options = [];
    if (s === '3') {
      options.push({ value: 0, label: 'Re-open' });
      return options;
    }
    if (s === '0' || s === '4' || s === '2') {
      options.push({ value: 1, label: 'Start' });
    } else if (s === '1') {
      options.push({ value: 4, label: 'Pause' });
    }
    if (s !== '2') {
      options.push({ value: 2, label: 'Block' });
    }
    options.push({ value: 3, label: 'Finish' });
    return options;
  }, [getCurrentUserStatus]);

  const currentStatusLabel = taskStatusMaper[getCurrentUserStatus] || 'Unknown';
  const canUseStatusMenu = showTaskStatusToolbar && taskStatusTransitionOptions.length > 0;

  // List of available assignees (you can replace this with data from an API)
  const notifyTopRight = (data) => {
    toast.success(`✔️ ${data}`, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: false,
      pauseOnHover: true,
      draggable: true,
    });
  };
  const notifyError = (data) => {

    toast.error(`❌ ${data}`, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };
  useEffect(() => {
    const fetchInitialData = async () => {
      try {
        const userData = JSON.parse(localStorage.getItem("user"));

        // Fetch users for assignees, observers, and mentions
        if (userData?.corporateId) {
          const params = new URLSearchParams();
          params.append('corporateId', parseInt(userData.corporateId));

          // Check user role to determine which filters to apply
          const scope = userData.dataScope || userData.data_scope || 'limited';
          const isCompany = isCorporateAdmin(userData.role || userData.type || '')
            || userData.system_key === 'corporate_super_admin';
          if (!isCompany && scope === 'full') {
            if (userData.subDepartmentId) {
              if (userData.branchId) params.append('branch', userData.branchId);
              if (userData.departmentId) params.append('department', userData.departmentId);
              params.append('sub_department', userData.subDepartmentId);
            } else if (userData.departmentId) {
              if (userData.branchId) params.append('branch', userData.branchId);
              params.append('department', userData.departmentId);
            } else if (userData.branchId) {
              params.append('branch', userData.branchId);
            }
          }

          const response = await axiosInstance.get(`/list/corporateuserslist?${params.toString()}`);
          const users = response.data.users || [];

          // Filter out the currently logged-in user
          const filteredUsers = users.filter(user => user.id !== userData.id);

          setAvailableAssignees(filteredUsers);
          userlist = filteredUsers;
          setMentions(filteredUsers)
          setTags(filteredUsers)
          setParticipants(filteredUsers)
          setObservers(filteredUsers)
        }

        // Fetch tasks
        const taskResponse = await axiosInstance.get('/task/list?page=1&limit=50');
        const taskData = taskResponse.data;
        setTasks(taskData.tasks || []);

      } catch (error) {
        console.error('Error fetching initial data:', error);

        // Handle 403 Forbidden error
        if (error.response && error.response.status === 409) {
          notifyError("Access denied. You don't have permission to access this Task.");
          // Navigate back to task list after a short delay
          setTimeout(() => {
            navigate('/task/tasklist');
          }, 2000);
          return;
        }

        toast.error('Failed to load initial data');
      }
    };

    fetchInitialData();
  }, []);
  function getMimeType(extension) {
    const mimeMap = {
      png: 'image/png',
      jpg: 'image/jpeg',
      jpeg: 'image/jpeg',
      pdf: 'application/pdf',
      doc: 'application/msword',
      docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      txt: 'text/plain',
      // Add more if needed
    };

    return mimeMap[extension.toLowerCase()] || 'application/octet-stream';
  }

  const fetchTaskDetails = async () => {
    try {
      const taskRes = await axiosInstance.get(`/task/taskdetails/${taskid}`);
      const taskDatas = taskRes.data;

      // Map the API response structure to the expected format
      const formattedStartDate = moment(taskDatas.start_date).format('YYYY-MM-DD HH:mm:ss');
      const formattedEndDate = moment(taskDatas.due_date).format('YYYY-MM-DD HH:mm:ss');
      const formattedRepeatUntil = moment(taskDatas.repeat_until).format('YYYY-MM-DD');
      setTaskStatus(String(taskDatas.status))


      const combined = taskDatas.history.map(item => {
        const user = userlist.find(u => u.CorporateUserId === item.ChangedBy || u.CorporateId === item.ChangedBy);
        return {
          ...item,
          Email: user ? user.Email : 'Unknown'
        };
      });

      if (combined != '') {
        setHistory(combined)
      }


      const enrichedMentionList = (taskDatas.Mentions || []).map(mention => {
        const matchedUser = (userlist || []).find(user => user.CorporateUserId === mention.id);
        return {
          ...mention,
          FullName: matchedUser?.FullName || '', // Add fallback
          Email: matchedUser?.Email || '',       // Optional: add more fields if needed
        };
      });

      const updatedChecklist = taskDatas.Checklists.map((item, index) => ({
        TaskChecklistId: item?.id || null, // if editing existing
        TaskId: item.task_id,
        value: item.content,
        checked: item.is_checked ? true : false,
        SortOrder: item.SortOrder,
        CreatedAt: new Date(item.added_at).toISOString(), // or keep the original timestamp if needed
        checked_by: item.CorporateUser ? item.CorporateUser.full_name : null,
        updated_at: item.updated_at ? formatDate(new Date(item.updated_at).toISOString()) : null
      }));
      setOldTaskData(taskDatas)
      setDelta(taskDatas.Delta)
      setDescription(taskDatas.Description)

      // Map the API response to the component's expected format
      // Store individual progress data if available
      if (taskDatas.individual_progress) {
        setIndividualProgress(taskDatas.individual_progress);
      }
      if (taskDatas.create_as_individual !== undefined) {
        setCreateAsIndividual(taskDatas.create_as_individual);
      }

      const startDateOnly = toDateOnlyString(taskDatas.start_date);
      const dueDateOnly = toDateOnlyString(taskDatas.due_date);
      const sameDayTimes = taskUsesSameDayTimes(startDateOnly, dueDateOnly);
      const showTaskTimes = sameDayTimes && (
        datetimeHasSpecificTime(taskDatas.start_date) || datetimeHasSpecificTime(taskDatas.due_date)
      );

      const testData = {
        title: taskDatas.title,
        start_date: startDateOnly,
        due_date: dueDateOnly,
        start_time: extractTimeFromDatetime(taskDatas.start_date),
        end_time: extractTimeFromDatetime(taskDatas.due_date),
        show_task_times: showTaskTimes,
        description: taskDatas.description,
        delta: taskDatas.delta,
        created_by: taskDatas.created_by,
        created_by_name: taskDatas.created_by_name,
        created_at: taskDatas.created_at || taskDatas.CreatedAt,
        reminder_internal_message: taskDatas.ReminderInternal,
        mark_high_priority: taskDatas.IsHighPriority,
        task_pin: taskDatas.PinTask,
        repeat_until: formattedRepeatUntil,
        assignee_list: taskDatas.assignee_list,
        mentions: enrichedMentionList,
        observers: taskDatas.observers,
        participants: [],
        status: returnStatusMap[parseInt(taskDatas.status)],
        files: (taskDatas.files),
        history: taskDatas.history,
        priority: taskDatas.priority,
        project_id: taskDatas.project_id,
        parent_task: taskDatas.parent_task,
        is_repeatable: taskDatas.is_repeatable,
        repeated_from_task_id: taskDatas.repeated_from_task_id,
        repeate_type: taskDatas.repeate_type,
        repeat_interval: taskDatas.repeat_interval,
        corporate_id: taskDatas.CorporateId,
        allow_shortcut: taskDatas.AllowShortCut,
        allow_assignee_update: taskDatas.AllowAssigneeUpdate,
        send_warning: taskDatas.SendWarning,
        close_checklist: taskDatas.CloseChecklist,
        is_assignee_update_allowed: taskDatas.is_assignee_update_allowed,
        project_name: taskDatas.project ? taskDatas.project.name : null,
        departments: taskDatas.department,
        branches: taskDatas.branch,
        sub_departments: taskDatas.subDepartments,
        completed_at: taskDatas.completed_at,
      }
      setTaskData({ ...taskData, ...testData });

      if (updatedChecklist != '') {
        setFields(updatedChecklist)
      }
      if (enrichedMentionList != '') {
        setMentions(enrichedMentionList)
      }
      setLoading(false);

    } catch (err) {
      console.error("Load all data error:", err);

      // Handle 403 Forbidden error
      if (err.response && err.response.status === 409) {
        notifyError("Access denied. You don't have permission to view this task.");
        // Navigate back to task list after a short delay
        setTimeout(() => {
          setLoading(false);
          navigate('/task/tasklist');
        }, 2000);
        return;
      } else if (err.response && err.response.status === 404)   {
        notifyError("Task not found.");
        // Navigate back to task list after a short delay
        setTimeout(() => {
          setLoading(false);
          navigate('/task/tasklist');
        }, 2000);
        return;
      } else {
        setLoading(false);
      }

      // Handle other errors
      notifyError("Failed to load task details. Please try again.");
    }

  }
  const fetchTaskCommentsDetails = async () => {
    try {
      const response = await axiosInstance.get(`/task/comments/${taskid}`);
      if (response.status !== 200) {
        throw new Error('Failed to fetch task details');
      }
      const data = response.data;
      setComments(data);
    } catch (err) {
      setError(err.message);

      // Handle 403 Forbidden error for comments
      if (err.response && err.response.status === 409) {
        notifyError("Access denied. You don't have permission to view this task.");
        // Navigate back to task list after a short delay
        setTimeout(() => {
          navigate('/task/tasklist');
        }, 2000);
        return;
      } else if (err.response && err.response.status === 404) {
        notifyError("Task not found.");
        // Navigate back to task list after a short delay
        setTimeout(() => {
          navigate('/task/tasklist');
        }, 2000);
        return;
      }
    }
  };

  useEffect(() => {
    if (taskid) {
      fetchTaskCommentsDetails();
      fetchTaskDetails();
    }
  }, [taskid]);

  // When navigating with #comment-{id} or ?comment={id}, switch to Comments tab (scroll handled by CommentSection)
  const scrollToCommentId = getCommentIdFromLocation(location);

  useEffect(() => {
    if (scrollToCommentId) {
      setActiveTab('comments');
    }
  }, [scrollToCommentId]);

  useEffect(() => {
    setuserdata(JSON.parse(localStorage.getItem("user")));
  }, []);

  const validateFields = (taskData) => {
    const errors = {};

    const isEmpty = (val) => !val || val.trim() === '';

    // ✅ title
    console.log("taskdata", taskData)
    if (isEmpty(taskData?.title)) {
      errors.title = "Task Name is required.";
    } else {
      delete errors.title;
    }

    // ✅ due_date (End Date)
    if (!taskData?.due_date) {
      errors.due_date = "End Date is required.";
    } else {
      delete errors.due_date;
    }

    // ✅ start_date < due_date
    if (
      taskData?.start_date &&
      taskData?.due_date &&
      new Date(taskData.start_date) > new Date(taskData.due_date)
    ) {
      errors.due_date = "End Date must be after Start Date.";
    }
    else {
      delete errors.due_date;
    }

    // ✅ repeat_until > start_date
    if (
      taskData?.start_date &&
      taskData?.repeat_until &&
      new Date(taskData.repeat_until) < new Date(taskData.start_date)
    ) {
      errors.repeat_until = "Repeat Until must be after Start Date.";
    } else {
      delete errors.repeat_until;
    }

    // ✅ Email format check (only if not empty)
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    ['email', 'reminder_email', 'task_status_email'].forEach((field) => {
      if (taskData?.[field]) {
        if (!emailRegex.test(taskData[field])) {
          errors[field] = `${field} is not a valid email.`;
        } else {
          delete errors[field];
        }
      } else {
        delete errors[field];
      }
    });

    console.log("errors", errors);
    setErrors(errors);
    return Object.keys(errors).length === 0;
  };

  async function normalizeFilesAndStore(files) {
    const finalFilesArray = await Promise.all(
      files.map(async (file) => {
        if (file instanceof File) return file;

        const id = file.id;
        const name = file.file_name || file.FileName;
        const ext = file.file_extension || file.FileExtension;

        if (id) {
          const response = await axiosInstance.get(`/task/attachments/${id}`, { responseType: 'blob' });
          const blob = response.data;
          const mimeType = getMimeType(ext);
          return new File([blob], name, { type: mimeType });
        }

        const legacyPath = `/task/${file.folder_name || file.FolderName}/${file.file_name || file.FileName}`;
        const response = await axiosInstance.get(legacyPath, { responseType: 'blob' });
        const blob = response.data;
        const mimeType = getMimeType(ext);
        return new File([blob], name, { type: mimeType });
      })
    );

    return finalFilesArray;
  }

  const handlePreview = (file) => {
    const fileUrl = URL.createObjectURL(file);
    setFilePreview({ file, url: fileUrl });
    setShowPreviewModal(true);
  };
  const handleFileClick = async (file) => {
    if (file instanceof File) {
      const fileURL = URL.createObjectURL(file);
      window.open(fileURL, '_blank');
      setTimeout(() => URL.revokeObjectURL(fileURL), 1000);
      return;
    }
    if (file && file.id) {
      try {
        await openTaskAttachmentInNewTab(file.id);
      } catch (e) {
        console.error(e);
        toast.error(e.message || 'Could not open attachment');
      }
    }
  };

  const handleChange = (e) => {
    const { name, value, type, checked, files } = e.target;
    console.log(name, value)

    if (type === 'checkbox') {
      setTaskData((prev) => ({
        ...prev,
        [name]: type === 'checkbox' ? 1 : 0
      }));
    } else if (name === 'assignee_list') {
      const options = e.target.selectedOptions;
      const selectedAssignees = Array.from(options).map((option) => option.value);
      setTaskData((prev) => ({
        ...prev,
        assignee_list: selectedAssignees
      }));
    }
    else if (type === 'file') {
      const newFiles = Array.from(files);
      setTaskData((prev) => {
        const existingFiles = prev[name] || [];
        const filteredFiles = newFiles.filter(
          (newFile) =>
            !existingFiles.some(
              (existingFile) =>
                existingFile.name === newFile.name &&
                existingFile.size === newFile.size
            )
        );
        return {
          ...prev,
          [name]: [...existingFiles, ...filteredFiles],
        };
      });
    }
    else if (name === 'tags') {
      try {
        const parsed = JSON.parse(value);
        if (Array.isArray(parsed)) {
          const joined = parsed.join(','); // Convert array to comma-separated string
          setTaskData(prev => ({ ...prev, tags: joined }));
        } else {
          toast.error('Tags should be a JSON array, e.g. ["tag1", "tag2"]');
        }
      } catch {
        setTaskData(prev => ({ ...prev, tags: value })); // fallback if user types manually
      }
      return;
    }
    else {
      setTaskData((prev) => ({
        ...prev,
        [name]: value
      }));
    }

    // Clear error on change
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: '' }));
    }
  };

  const handleTaskEdit = (event, taskid) => {
    // If it's a repeat task instance, show confirmation modal
    if (taskData?.repeated_from_task_id) {
      setShowEditModal(true);
    } else if (taskData?.is_repeatable) {
      // If it's a root repeatable task, show warning that editing affects all instances
      setShowEditModal(true);
    } else {
      // Normal edit - navigate directly
      navigate('/task/edittask', {
        state: { taskid },
      });
    }
  };

  const handleEditInstance = () => {
    setShowEditModal(false);
    navigate('/task/edittask', {
      state: { taskid },
    });
  };

  const handleEditSeries = () => {
    setShowEditModal(false);
    // Use repeated_from_task_id for editing entire series (if it's an instance)
    // Or use the task's own ID if it's a root task
    const taskIdToEdit = taskData.repeated_from_task_id || taskid;
    navigate('/task/edittask', {
      state: { taskid: taskIdToEdit },
    });
  };

  const handleDeleteWithConfirmation = () => {
    setShowDeleteModal(true);
  };

  const handleDeleteInstance = async () => {
    setShowDeleteModal(false);
    const isRootTask = taskData?.is_repeatable && !taskData?.repeated_from_task_id;
    const data = { taskId: taskid };
    if (isRootTask) data.deleteFirstInstanceOnly = true;

    try {
      const res = await axiosInstance.delete('/task/deletetask', { data });
      if (res) {
        toast.success(isRootTask ? "Task deleted successfully" : "Task instance deleted successfully");
        navigate(taskListFallback);
      }
    } catch (err) {
      toast.error(err.response?.data?.message || "Error in deleting task instance");
      console.error(err);
    }
  };

  const handleDeleteSeries = async () => {
    setShowDeleteModal(false);
    // For instance: use repeated_from_task_id (root id); for root: use taskid (root is the series)
    const seriesTaskId = taskData.repeated_from_task_id ?? taskid;

    try {
      const res = await axiosInstance.delete('/task/deletetask', { data: { taskId: seriesTaskId } });
      if (res) {
        toast.success("Repeat task series deleted successfully");
        navigate(taskListFallback);
      }
    } catch (err) {
      toast.error(err.response?.data?.message || "Error in deleting task series");
      console.error(err);
    }
  };

  const handleDeleteNormal = async () => {
    setShowDeleteModal(false);
    const isRootTask = taskData?.is_repeatable && !taskData?.repeated_from_task_id;
    
    try {
      const res = await axiosInstance.delete('/task/deletetask', { data: { taskId: taskid } });
      if (res) {
        if (isRootTask) {
          toast.success("Repeat task series deleted successfully");
        } else {
          toast.success("Task deleted successfully");
        }
        navigate(taskListFallback);
      }
    } catch (err) {
      toast.error(err.response?.data?.message || "Error in deleting");
      console.error(err);
    }
  };


  const handleRemoveFile = (index) => {
    // Remove the file at the given index from the files array
    const updatedFiles = taskData.files.filter((_, i) => i !== index);

    // Update taskData with the new files array
    setTaskData((prev) => ({
      ...prev,
      files: updatedFiles,
    }));

    // Reset the file input value (clear the input field)
    if (fileInputRef.current) {
      fileInputRef.current.value = ''; // Clears the file input field
    }
  };
  const handleChangeFields = (e, index) => {
    const updated = [...fields];
    updated[index].value = e.target.value;
    setFields(updated);
  };
  const handleCheckboxToggle = async (index) => {
    const updated = [...fields];
    const field = updated[index];
    const newChecked = !field.checked;
    // Optimistically update UI
    updated[index].checked = newChecked;
    setFields(updated);

    // Prepare API call
    const checklistId = field.TaskChecklistId;
    if (!checklistId) {
      return;
    }
    try {
      const response = await axiosInstance.post('/task/checklist/update-completion', {
        checklistId: checklistId,
        isCompleted: newChecked ? 1 : 0
      });
      if (response.status === 200) {
        setChangedFields(prev => ([...prev, `Checklist ${field.value} marked as ${newChecked ? 'completed' : 'incomplete'}`]));
        fetchTaskDetails(); // Refresh task details to get updated checked_by info
      } else {
        throw new Error('Failed to update checklist');
      }
    } catch (err) {
      // Revert UI on error
      updated[index].checked = !newChecked;
      setFields(updated);
    }
  };

  const handleDelete = (index) => {
    const updated = fields.filter((_, i) => i !== index);
    setFields(updated.length > 0 ? updated : [{ value: '', checked: false, isEditing: true }]);
  };
  const addChecklist = (index) => {
    const updated = [...fields];
    updated[index].isEditing = false;
    updated.splice(index + 1, 0, { value: '', checked: false, isEditing: true });
    setFields(updated);
  };

  const handleEdit = (index) => {
    const updated = [...fields];
    updated[index].isEditing = true;
    setFields(updated);
  };
  const handleKeyDown = (e, index) => {
    if (e.key === 'Enter') {
      const updated = [...fields];
      updated[index].isEditing = false;
      setFields(updated);
    }
  };

  const handleSave = (index) => {
    const updatedFields = [...fields];
    updatedFields[index].isEditing = false;
    setFields(updatedFields);
  };

  const handleChangeDescription = useCallback(({ description, mentions, delta }) => {
    const { cleanedDescription } = extractMentionsAndCleanDescription(description);

    setTaskData((prev) => {
      const newState = {
        ...prev,
        description: cleanedDescription || description,
        mentions: mentions,
        delta: delta,
      };
      return newState;
    });
  }, []);
  const extractMentionsAndCleanDescription = (html) => {
    const div = document.createElement('div');
    div.innerHTML = html;

    const mentions = [];

    // Handle mentions - replace with plain text but preserve structure
    const mentionSpans = div.querySelectorAll('span.mention');
    mentionSpans.forEach((span) => {
      const name = span.innerText || span.textContent;
      const id = span.dataset.id;

      mentions.push({ id, name });

      // Replace with a text node to preserve list structure
      const textNode = document.createTextNode(name);
      span.parentNode.replaceChild(textNode, span);
    });

    // Remove cursor spans
    const cursorSpans = div.querySelectorAll('span.ql-cursor');
    cursorSpans.forEach(span => span.remove());

    // Clean up any empty list items that might have been created
    const emptyListItems = div.querySelectorAll('li:empty');
    emptyListItems.forEach(li => {
      // Only remove if it's truly empty (no text content)
      if (!li.textContent.trim()) {
        li.remove();
      }
    });

    // Clean up empty lists
    const emptyLists = div.querySelectorAll('ul:empty, ol:empty');
    emptyLists.forEach(list => list.remove());

    // Get final cleaned HTML and plain text
    const cleanedDescription = div.innerHTML.trim();
    const plainText = div.textContent || div.innerText || '';

    return {
      cleanedDescription,  // HTML string with mentions replaced as plain text
      plainText,           // Pure plain text
      mentions             // Array of { id, name }
    };
  };
  function extractMentionsWithPositions(html) {
    const mentions = [];
    const mentionRegex = /<span class="mention"[^>]*data-id="(\d+)"[^>]*>(.*?)<\/span>/g;

    let match;
    while ((match = mentionRegex.exec(html)) !== null) {
      const fullMatch = match[0];
      const corporateUserId = parseInt(match[1]);
      const mentionText = match[2];
      const positionIndex = match.index;

      mentions.push({
        CorporateUserId: corporateUserId,
        MentionText: mentionText,
        PositionIndex: positionIndex
      });
    }

    return mentions;
  }

  // Utility function to convert Delta to HTML using Quill
  function deltaToHtml(delta) {
    try {
      let parsedDelta = delta;
      while (typeof parsedDelta === 'string') {
        parsedDelta = JSON.parse(parsedDelta);
      }
      const tempQuill = new Quill(document.createElement('div'));
      tempQuill.setContents(parsedDelta);
      return tempQuill.root.innerHTML;
    } catch (err) {
      console.error('Failed to parse delta:', err);
      return '';
    }
  }

  const customStyles = {
    control: (base, state) => ({
      ...base,
      borderRadius: '10px',
      borderColor: state.isFocused ? '#198754' : 'rgba(0, 0, 0, 0.125)', // green on focus, blue by default
      boxShadow: 'none',
      '&:hover': {
        borderColor: '#198754',
      },
    }),
    menu: (base) => ({
      ...base,
      borderRadius: '10px',
      zIndex: 9999,
    }),
  };
  // Unified status change handler
  const handleStatusChange = async (newStatus) => {
    let user = JSON.parse(localStorage.getItem("user"));

    // Block complete/closed when checklist items remain open
    if (Number(newStatus) === 3) {
      const incompleteChecklists = (fields || []).filter(
        (item) => item?.value?.trim() && !item.checked
      );
      if (incompleteChecklists.length > 0) {
        notifyError('Please complete all checklist items before marking this task as completed.');
        return;
      }
    }

    setStatusChangeLoading(true);
    try {
      const response = await axiosInstance.post('/task/statuschange', {
        taskId: taskid,
        status: newStatus,
        UpdatedBy: user?.id
      });
      if (response.status === 200) {
        setTaskStatus(String(newStatus));
        // Update statusChange for play/pause toggle
        if (newStatus === 1) setStatusChange('PAUSE');
        else if (newStatus === 4) setStatusChange('START');
        
        // Refresh task details, history, and comments after successful status change
        await Promise.all([
          fetchTaskDetails(),
          fetchTaskCommentsDetails()
        ]);
        
        // Show success notification
        notifyTopRight(`Task status updated to ${returnStatusMap[newStatus]}`);
      }
    } catch (error) {
      console.error('Error updating status:', error);
      notifyError(error.response?.data?.message || error.message || 'Failed to update task status');
    } finally {
      setStatusChangeLoading(false);
    }
  }
  const saveHandler = async (e) => {
    e.preventDefault();
    let taskData = oldTaskData;
    // Validate form fields before submission
    if (validateFields(taskData) == false) return;

    const safeAppend = (key, value) => {
      if (
        value !== undefined &&
        value !== null &&
        value !== '' &&
        !(Array.isArray(value) && value.length === 0)
      ) {
        formData.append(key, value);
      }
    };

    // Convert dates to 'YYYY-MM-DD' format for date fields and timestamp for time fields
    const numericStatus = statusMap[taskData.Status] ?? 0;
    const formData = new FormData(); // ✅ must use FormData, not plain object

    if (userdata) {
      safeAppend('TaskId', taskid)
      safeAppend('TaskName', taskData.title);
      safeAppend('ProjectId', taskData.project_id);
      safeAppend('Description', taskData.description);
      safeAppend('Delta', JSON.stringify(taskData.delta));
      safeAppend('AllowShortCut', taskData.allow_shortcut);
      safeAppend('Priority', taskData.priority);
      safeAppend('Status', numericStatus);

      // Dates
      const applySameDayTimes = taskUsesSameDayTimes(taskData.start_date, taskData.due_date);
      safeAppend('StartDate', buildTaskDatetime(taskData.start_date, taskData.start_time, applySameDayTimes));
      safeAppend('EndDate', buildTaskDatetime(taskData.due_date, taskData.end_time, applySameDayTimes));

      // Optional fields
      safeAppend('RepeatType', taskData.repeate_type);
      safeAppend('RepeatInterval', taskData.repeat_interval);
      safeAppend('RepeatUntil', taskData.repeat_until ? moment(taskData.repeat_until).format('YYYY-MM-DD') : '');
      safeAppend('AllowAssigneeUpdate', taskData.allow_assignee_update);
      safeAppend('AllowEmailUpdates', taskData.AllowEmailUpdate);
      safeAppend('SendWarning', taskData.send_warning);
      safeAppend('CloseChecklist', taskData.close_checklist);

      // User fields
      safeAppend('CreatedBy', userdata?.id);
      safeAppend('CreatedName', userdata?.name);
      safeAppend('ReminderEmail', userdata?.email);
      safeAppend('TaskStatusEmail', userdata?.email);
      safeAppend('Email', userdata?.email);

      // JSON-encoded arrays/objects
      if (taskData.mentions.length) {
        const result = taskData.mentions.map(item1 => {
          const match = availableAssignees.find(item2 => item2.CorporateUserId === parseInt(item1.id));
          return match || null;
        }).filter(Boolean);
        safeAppend('Mentions', JSON.stringify(result))

      }
      if (taskData.tags?.length) {
        safeAppend('Tags', JSON.stringify(taskData.tags));
      }
      if (taskData.assignee_list?.length) {
        safeAppend('Assignees', JSON.stringify(taskData.assignee_list));
      }
      if (taskData.participants?.length) {
        safeAppend('Participants', JSON.stringify(taskData.participants));
      }
      if (taskData.observers?.length) {
        safeAppend('Observers', JSON.stringify(taskData.observers));
      }
      const filteredChecklist = checklist.filter(
        item => item.ChecklistItem && item.ChecklistItem.trim() !== ""
      );
      if (filteredChecklist?.length) {
        safeAppend('ChecklistJSON', JSON.stringify(checklist))
      }
      if (taskData.reminder_internal_message) {
        safeAppend('ReminderInternal', taskData.reminder_internal_message)
      }
      if (taskData.reminder_through_email) {
        safeAppend("ReminderEmailFlag", taskData.reminder_through_email)
      }
      if (taskData.mark_high_priority) {
        safeAppend("HighPriority", taskData.mark_high_priority)
      }
      if (taskData.task_pin) {
        safeAppend("PinTask", taskData.task_pin)
      }
      if (changedFields) {
        safeAppend('changedFields', changedFields)
      }

      console.log("changedFields", changedFields)
      // Append files
      if (taskData.files && taskData.files.length > 0) {
        let filesArray = await normalizeFilesAndStore(taskData.files);
        console.log(filesArray)
        filesArray.forEach(file => {
          formData.append('Files', file);
        });
      }

      if (taskData.parent_task != '') {
        formData.append("ParentTaskId", taskData.parent_task)
      }
      else {
        formData.append("ParentTaskId", null)
      }

      try {
        const response = await axiosInstance.put('/task/updatetask', formData);

        const result = response.data;
        if (result && result.success === false) {
          toast.error(result.error || result.message || 'Failed to update task');
        } else if (response.status === 200) {
          // Handle success - you can display a success message or navigate to another route
          toast.success("Task updated successfully")
          setTimeout(() => {
            navigateBackSafely(); // navigate to another route after delay
          }, 3000);
        } else {
          // Handle errors if the response status is not 200 OK
          console.error('Error updating task:', result);
          toast.error(result?.message || 'Failed to update task');
        }
      } catch (error) {
        console.error('Error during API call:', error);
        toast.error(error.response?.data?.error || error.response?.data?.message || error.message || 'Error updating task');
      } finally {
        setIsSubmitting(false);
      }
    }

  }
  const handleFinish = async () => {
    try {
      let user = JSON.parse(localStorage.getItem("user"));
      const response = await axiosInstance.post('/task/statuschange', {
        taskId: taskid,
        status: 4,
        UpdatedBy: user?.id
      });

      const result = response.data;

      if (response.status === 200) {
        setStatusChange('FINISH')
        setTaskStatus("4")
        console.log('Success:', result);
      }
    } catch (error) {
      console.error('Error updating status:', error);
    }
  }

  const handleExportTransactionStatement = async () => {
    try {
      const rememberMe = localStorage.getItem('rememberMe') === 'true';
      const rawToken = rememberMe ? localStorage.getItem('accessToken') : sessionStorage.getItem('accessToken') || localStorage.getItem('tempAccessToken');
      const token = rawToken ? JSON.parse(rawToken) : null;
      const baseUrl = process.env.REACT_APP_API_URL || '';
      const url = `${baseUrl}/task/comments/${taskid}/export-xlsx`;
      const headers = {};
      if (token) headers.Authorization = `Bearer ${token}`;
      const res = await fetch(url, { method: 'GET', headers });
      if (!res.ok) throw new Error('Export failed');
      const blob = await res.blob();
      const downloadUrl = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = downloadUrl;
      const taskName = (taskData.title || 'Task').replace(/[^a-zA-Z0-9_-]/g, '_');
      a.download = `Task_Comments_${taskName}_${taskid}.xlsx`;
      a.click();
      window.URL.revokeObjectURL(downloadUrl);
      notifyTopRight('Transaction statement exported successfully');
    } catch (err) {
      console.error('Export error:', err);
      notifyError(err.response?.data?.message || 'Failed to export transaction statement');
    }
  };

  // Expose fetchTaskCommentsDetails for CommentSection
  const handleCommentAdded = () => {
    if (taskid) {
      // Re-fetch comments after a new comment is added
      axiosInstance.get(`/task/comments/${taskid}`)
        .then(response => {
          if (response.status === 200) {
            setComments(response.data);
          }
        })
        .catch(err => setError(err.message));
    }
  };

  const taskDetailToolbar = useMemo(() => (
    <>
      <div className="page-toolbar-bar__start">
        <button
          type="button"
          className="page-toolbar-back-btn"
          onClick={() => navigateBackSafely()}
          title="Back"
          aria-label="Back"
        >
          <FiArrowLeft />
          Back
        </button>
      </div>
      {!loading && taskData && Object.keys(taskData).length > 0 ? (
        <div className="page-toolbar-bar__end">
          <div className="forum-title-row__status">
            {canUseStatusMenu ? (
              <Dropdown align="end" className="forum-status-menu">
                <Dropdown.Toggle
                  variant="link"
                  className="forum-title-row-btn forum-status-btn"
                  aria-label="Change task status"
                  disabled={statusChangeLoading}
                >
                  <span className="forum-status-btn__label">{currentStatusLabel}</span>
                  <i className="fas fa-chevron-down forum-status-btn__chevron" aria-hidden></i>
                </Dropdown.Toggle>
                <Dropdown.Menu
                  className="forum-status-menu__dropdown"
                  popperConfig={{ strategy: 'fixed' }}
                  renderOnMount
                >
                  {taskStatusTransitionOptions.map((option) => (
                    <Dropdown.Item
                      key={option.value}
                      onClick={() => handleStatusChange(option.value)}
                    >
                      {option.label}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>
            ) : (
              <span className="forum-title-row-btn forum-status-btn forum-status-btn--readonly">
                {currentStatusLabel}
              </span>
            )}
          </div>
          <button
            type="button"
            className={`header-toolbar-btn${infoOpen ? ' is-active' : ''}`}
            onClick={() => setInfoOpen((open) => !open)}
            aria-expanded={infoOpen}
            aria-controls="task-info-panel"
            title="Info"
            aria-label="Info"
          >
            <i className="fas fa-info-circle" aria-hidden></i>
          </button>
          {canExportTask && (
            <button
              type="button"
              className="header-toolbar-btn"
              onClick={handleExportTransactionStatement}
              title="Export comments"
              aria-label="Export comments"
            >
              <i className="fa fa-download" aria-hidden></i>
            </button>
          )}
          {showEditToolbar && (
            <button
              type="button"
              className="header-toolbar-btn"
              onClick={(e) => handleTaskEdit(e, taskid)}
              title="Edit"
              aria-label="Edit"
            >
              <i className="fa fa-edit" aria-hidden></i>
            </button>
          )}
          {showDeleteToolbar && (
            <button
              type="button"
              className="header-toolbar-btn"
              onClick={handleDeleteWithConfirmation}
              title="Delete"
              aria-label="Delete"
            >
              <i className="fa fa-trash" aria-hidden></i>
            </button>
          )}
        </div>
      ) : null}
    </>
  ), [
    loading,
    taskData,
    canUseStatusMenu,
    statusChangeLoading,
    currentStatusLabel,
    taskStatusTransitionOptions,
    infoOpen,
    showEditToolbar,
    showDeleteToolbar,
    canExportTask,
    comments.length,
    taskid,
  ]);

  usePageToolbar(taskDetailToolbar, [taskDetailToolbar]);

  if (!taskid) {
    return <div>No task selected. Please go back to the task list.</div>;
  }

  // Show loading screen when API is loading
  if (loading) {
    return (
      <React.Fragment>
        <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
          <div className="text-center">
            <div className="spinner-border text-primary" role="status" style={{ width: '3rem', height: '3rem' }}>
              <span className="visually-hidden">Loading...</span>
            </div>
            <div className="mt-3">
              <h5>Loading task details...</h5>
              <p className="text-muted">Please wait while we fetch the task information.</p>
            </div>
          </div>
        </div>
        <ToastContainer />
      </React.Fragment>
    );
  }

  return (
    <React.Fragment>
      <div className="row forum-detail-row">
        <ToastContainer />
        <div className="col-xl-12 col-xxl-12">
          <div className="card heightcard forum-detail-card">
            <div className="card-header details-card-header forum-section-header forum-title-block">
              <div className="forum-title-block__info">
                <h5 className="text-base sm:text-lg font-semibold mb-0 forum-title-row__title">
                  <span className="forum-title-row__title-text">
                    {(taskData.is_repeatable || taskData.repeated_from_task_id) && (
                      <i
                        className="fas fa-sync-alt me-2"
                        title={taskData.repeated_from_task_id
                          ? `Repeatable task instance (from task #${taskData.repeated_from_task_id})`
                          : 'Repeatable task (Root)'}
                        style={{ color: '#007bff', fontSize: '1rem' }}
                      />
                    )}
                    {taskData.title}
                  </span>
                </h5>
                <div className="forum-title-block__labels">
                  {taskData.start_date === taskData.due_date ? (
                    <span className="forum-title-meta-label">
                      Date: {taskData.start_date ? formatDateToDDMMMYYYY(taskData.start_date) : 'N/A'}
                      {taskData.show_task_times && taskData.start_time && taskData.end_time
                        ? ` · ${taskData.start_time} - ${taskData.end_time}`
                        : ''}
                    </span>
                  ) : (
                    <>
                      <span className="forum-title-meta-label">
                        Start Date: {taskData.start_date ? formatDateToDDMMMYYYY(taskData.start_date) : 'N/A'}
                      </span>
                      <span className="forum-title-meta-label">
                        End Date: {taskData.due_date ? formatDateToDDMMMYYYY(taskData.due_date) : 'N/A'}
                      </span>
                    </>
                  )}
                  <span className="forum-title-meta-label">
                    Priority: {taskData.priority ? taskData.priority.charAt(0).toUpperCase() + taskData.priority.slice(1) : 'Not set'}
                  </span>
                </div>
              </div>
            </div>
            <div className="card-body forum-detail-card__body">
              <section>
                <div className="row">
                  {(individualTaskStatusHintMessage || observerNormalTaskHintMessage) && (
                    <div className="col-12 mb-3">
                      <p className="text-muted mb-0" style={{ fontSize: '0.95rem' }}>
                        {individualTaskStatusHintMessage || observerNormalTaskHintMessage}
                      </p>
                    </div>
                  )}

                  {taskData.delta || taskData.description ? (
                    <div className="mb-4">
                      <div className="forum-description-content">
                        <ReadOnlyQuill
                          delta={taskData.delta}
                          html={taskData.description}
                          style={{ minHeight: '100px' }}
                        />
                      </div>
                    </div>
                  ) : null}

                  {/* Checklist Section: Only show if there are checklist items with non-empty values */}
                  {fields.length > 0 && fields.some(field => field.value && field.value.trim() !== "") && (
                    <div className="col-lg-12 mb-2">
                      <label className="text-label">Checklist</label>
                      <div className="checklist-container checklist-details p-3">
                        {fields
                          .filter(field => field.value && field.value.trim() !== "")
                          .map((field, index) => (
                            <div
                              key={field.TaskChecklistId || `temp-${index}`}
                              className="checklist-item-row d-flex mb-2"
                              style={{
                                minHeight: '36px',
                                gap: '10px',
                                background: 'transparent',
                                border: 'none',
                                boxShadow: 'none',
                                padding: '0 8px'
                              }}
                            >
                              <input
                                type="checkbox"
                                className="form-check-input checklist-item-checkbox"
                                checked={field.checked}
                                onChange={() => handleCheckboxToggle(index)}
                                disabled={disableCheckbox}
                              />

                              <span
                                className="checklist-item-text"
                                style={{
                                  fontSize: '1rem',
                                  color: field.checked ? '#888' : '#222',
                                  textDecoration: field.checked ? 'line-through' : 'none',
                                  paddingLeft: '4px'
                                }}
                              >
                                {field.value}
                              </span>
                              {field.checked_by && field.checked ?
                                <span style={{
                                  fontSize: '0.8rem',
                                  color: '#555',
                                }}>{`(checked by ${field.checked_by} at ${formatDateTimeToDDMMMYYYY(field.updated_at, false)})`}</span> : null}
                            </div>
                          ))}
                      </div>
                    </div>
                  )}
                  {/* Files & Images Section */}
                  {taskData.files && taskData.files.length > 0 && (
                    <div className="col-lg-12 mb-2">
                      <label className="text-label">Attachments</label>
                      <div className="attachments-container p-3" style={{ background: '#f9f9f9', borderRadius: 6 }}>
                        <div className="row">
                          {taskData.files.map((file, idx) => {
                            const fileName = file.name || file.file_name;
                            const isImage = (file.type || file.file_extension || '').match(/(jpg|jpeg|png|gif|bmp|webp|svg)/i);
                            const fileId = file.id;
                            const openAttachment = (e) => {
                              if (e && e.stopPropagation) e.stopPropagation();
                              handleFileClick(file);
                            };
                            return (
                              <div
                                className="col-6 col-md-4 col-lg-3 mb-3 d-flex flex-column align-items-center"
                                key={fileId || idx}
                                onClick={fileId ? openAttachment : undefined}
                                style={{ cursor: fileId ? 'pointer' : 'default' }}
                              >
                                <div style={{ width: '100%', textAlign: 'center' }} >
                                  {isImage && fileId ? (
                                    <TaskAttachmentImage
                                      fileId={fileId}
                                      alt={fileName}
                                      style={{ maxWidth: '100%', maxHeight: 80, borderRadius: 4, cursor: 'pointer', marginBottom: 4 }}
                                      onClick={openAttachment}
                                    />
                                  ) : isImage && !fileId ? (
                                    <div style={{ fontSize: 12, color: '#888' }}>Reload to preview</div>
                                  ) : (
                                    <i className="fa fa-file" style={{ fontSize: 40, color: '#888', marginBottom: 4 }} onClick={fileId ? openAttachment : undefined} />
                                  )}
                                </div>
                                <div style={{ wordBreak: 'break-all', fontSize: 13 }}>{fileName}</div>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </section>
            </div>
          </div>

          <div className="card heightcard forum-comments-card">
            <div className="card-header details-card-header forum-section-header">
              <h5 className="text-base sm:text-lg font-semibold mb-0">Activity</h5>
            </div>
            <div className="card-body forum-comments-card-body p-0">
            <div className="default-tab">
              <Tab.Container activeKey={activeTab} onSelect={(k) => setActiveTab(k || 'comments')}>
                <Nav as="ul" className="nav-tabs">
                  <Nav.Item as="li">
                    <Nav.Link eventKey="comments" className="d-flex align-items-center justify-content-center gap-2">
                      <span>Comments</span>
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item as="li">
                    <Nav.Link eventKey="history">
                      History
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item as="li">
                    <Nav.Link eventKey="daily-updates">
                      Transaction statement
                    </Nav.Link>
                  </Nav.Item>
                  {/* <Nav.Item as="li">
                    <Nav.Link eventKey="time">
                      Time
                    </Nav.Link>
                  </Nav.Item> */}
                </Nav>

                <Tab.Content className="p-4">
                  <Tab.Pane eventKey="comments">
                    <CommentSection
                      users={availableAssignees}
                      comments={comments}
                      onCommentAdded={handleCommentAdded}
                      taskid={taskid}
                      scrollToCommentId={scrollToCommentId}
                    />
                  </Tab.Pane>

                  <Tab.Pane eventKey="daily-updates">
                    <div className="daily-updates-tab">
                      <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
                        <h6 className="mb-0" style={{ fontWeight: 600, color: '#333' }}>Your transaction statements</h6>
                        <Link
                          to={`/task/taskdetails/${taskid}/daily-updates`}
                          className="btn btn-sm btn-transaction-statement btn-daily-updates-action"
                          title="View all transaction statements"
                        >
                          See all statement
                        </Link>
                      </div>
                      <div className="daily-updates-list" style={{ maxHeight: '400px', overflowY: 'auto' }}>
                        {(() => {
                          const currentUserId = userdata?.id;
                          const topLevel = (comments || []).filter(c => !c.parent_id);
                          const topLevelByUser = currentUserId ? topLevel.filter(c => c.user_id === currentUserId) : [];
                          const repliesByUser = topLevel.flatMap(c => (c.replies || []).filter(r => r.user_id === currentUserId));
                          const filtered = [...topLevelByUser, ...repliesByUser].sort(
                            (a, b) => new Date(b.updated_at || b.created_at) - new Date(a.updated_at || a.created_at)
                          );
                          if (filtered.length === 0) {
                            return (
                              <p className="text-muted mb-0">
                                No daily updates by you yet.
                              </p>
                            );
                          }
                          return filtered.map((item) => {
                            const displaySubject = getDisplaySubject(item.subject, item.content);
                            return (
                              <div
                                key={item.id}
                                className="daily-update-item mb-3 p-3"
                                style={{
                                  background: '#f9f9f9',
                                  border: '1px solid #e8e8e8',
                                  borderRadius: '8px',
                                  fontSize: '0.9rem',
                                }}
                              >
                                <div className="d-flex justify-content-between align-items-start">
                                  <span style={{ fontWeight: 400, color: '#333', fontSize: '1rem' }}>{displaySubject}</span>
                                  <span style={{ color: '#666', fontSize: '0.8rem' }}>{formatDateTimeToDDMMMYYYY(item.updated_at || item.created_at)}</span>
                                </div>
                              </div>
                            );
                          });
                        })()}
                      </div>
                    </div>
                  </Tab.Pane>

                  <Tab.Pane eventKey="history">
                    <div className="table-responsive recentOrderTable">
                      <table className="table verticle-middle table-responsive-md task-history-table">
                        <thead>
                          <tr>
                            <th scope="col">Date</th>
                            <th scope="col">Changed By</th>
                            <th scope="col">Update Description</th>

                          </tr>
                        </thead>
                        <tbody>
                          {mergedHistory.map((group) => (
                            <tr key={group.id}>
                              <td>{formatDateTimeToDDMMMYYYY(group.created_at)}</td>
                              <td>{group.changed_by_user.full_name}</td>
                              <td>{group.message}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>

                    </div>
                  </Tab.Pane>
                </Tab.Content>
              </Tab.Container>
            </div>
            </div>
          </div>
        </div>
      </div>

      {infoOpen && (
        <button
          type="button"
          className="forum-info-backdrop"
          onClick={() => setInfoOpen(false)}
          aria-label="Close info panel"
        />
      )}

      <aside
        id="task-info-panel"
        className={`forum-info-drawer${infoOpen ? ' forum-info-drawer--open' : ''}`}
        aria-hidden={!infoOpen}
      >
        <div className="forum-info-drawer-header">
          <h6 className="forum-info-drawer-title mb-0">Info</h6>
          <button
            type="button"
            className="forum-info-drawer-close"
            onClick={() => setInfoOpen(false)}
            aria-label="Close info panel"
          >
            <i className="fas fa-times" aria-hidden></i>
          </button>
        </div>
        <div className="forum-info-drawer-body">
          <div className="forum-info-field">
            <p className="forum-info-field-label">Status</p>
            <p className="forum-info-field-value">{statusBoxTitle}</p>
          </div>
          <div className="forum-info-field">
            <p className="forum-info-field-label">Created on</p>
            <p className="forum-info-field-value">
              {taskData.created_at ? formatDateTimeToDDMMMYYYY(taskData.created_at) : '—'}
            </p>
          </div>
          {getCurrentUserStatus === '3' && taskData.completed_at && (
            <div className="forum-info-field">
              <p className="forum-info-field-label">Completed on</p>
              <p className="forum-info-field-value">{formatDateTimeToDDMMMYYYY(taskData.completed_at)}</p>
            </div>
          )}
          {taskData.project_name && (
            <div className="forum-info-field">
              <p className="forum-info-field-label">Project</p>
              <p className="forum-info-field-value">
                {canAccessProjects && taskData.project_id ? (
                  <Link
                    to={`/task/projectdetails/${taskData.project_id}`}
                    className="text-primary"
                    style={{ textDecoration: 'none' }}
                  >
                    {taskData.project_name}
                  </Link>
                ) : (
                  taskData.project_name
                )}
              </p>
            </div>
          )}
          {taskData.is_repeatable && (
            <div className="forum-info-field">
              <p className="forum-info-field-label">Repeat every</p>
              <p className="forum-info-field-value">
                {taskData.repeat_interval === 1 ? '' : taskData.repeat_interval}{' '}
                {taskData.repeate_type === 'Daily' ? 'day' : taskData.repeate_type === 'Weekly' ? 'week' : taskData.repeate_type === 'Monthly' ? 'month' : ''}
              </p>
            </div>
          )}
          <div className="forum-info-field">
            <p className="forum-info-field-label">Created by</p>
            <div className="user-chip-list forum-info-participants">
              <div className="user-chip">
                <span className="user-chip-avatar">
                  {taskData.created_by_name ? taskData.created_by_name[0] : '?'}
                </span>
                {taskData.created_by_name}
              </div>
            </div>
          </div>
          <div className="forum-info-field">
            <p className="forum-info-field-label">Assignees</p>
            {taskData.assignee_list?.length > 0 ||
            taskData.sub_departments?.some((s) => s.is_assignee) ||
            taskData.departments?.some((d) => d.is_assignee) ||
            taskData.branches?.some((b) => b.is_assignee) ? (
              <div className="user-chip-list forum-info-participants">
                {taskData.assignee_list?.map((assignee) => (
                  <div className="user-chip" key={assignee.CorporateUserId || assignee.Email}>
                    <span className="user-chip-avatar">
                      {assignee.full_name ? assignee.full_name[0] : '?'}
                    </span>
                    {assignee.full_name}
                  </div>
                ))}
                {taskData.sub_departments
                  ?.filter((subDept) => subDept.is_assignee === true)
                  .map((subDept) => (
                    <div className="user-chip" key={`sub_dept-${subDept.id}`}>
                      <span className="user-chip-avatar">
                        <i className="fa fa-building" aria-hidden></i>
                      </span>
                      {subDept.name}
                    </div>
                  ))}
                {taskData.departments
                  ?.filter((dept) => dept.is_assignee === true)
                  .map((dept) => (
                    <div className="user-chip" key={`dept-${dept.department_id}`}>
                      <span className="user-chip-avatar">
                        <i className="fa fa-building" aria-hidden></i>
                      </span>
                      {dept.Department.name}
                    </div>
                  ))}
                {taskData.branches
                  ?.filter((branch) => branch.is_assignee === true)
                  .map((branch) => (
                    <div className="user-chip" key={`branch-${branch.branch_id}`}>
                      <span className="user-chip-avatar">
                        <i className="fa fa-sitemap" aria-hidden></i>
                      </span>
                      {branch.Branch.name}
                    </div>
                  ))}
              </div>
            ) : (
              <p className="forum-info-field-value">—</p>
            )}
          </div>
          <div className="forum-info-field">
            <p className="forum-info-field-label">Observers</p>
            {taskData.observers?.length > 0 ? (
              <div className="user-chip-list forum-info-participants">
                {taskData.observers.map((observer) => (
                  <div className="user-chip" key={observer.CorporateUserId || observer.Email}>
                    <span className="user-chip-avatar">
                      {observer.full_name ? observer.full_name[0] : '?'}
                    </span>
                    {observer.full_name}
                  </div>
                ))}
              </div>
            ) : (
              <p className="forum-info-field-value">—</p>
            )}
          </div>
          {createAsIndividual && individualProgress && individualProgress.type === 'creator_view' && (
            <div className="forum-info-field">
              <p className="forum-info-field-label">Individual progress</p>
              <p className="forum-info-field-value mb-2">
                {individualProgress.stats.completion_percentage}% complete
              </p>
              <div style={{ maxHeight: '240px', overflowY: 'auto' }}>
                {individualProgress.all_progress?.map((userProgress) => (
                  <div
                    key={userProgress.id}
                    className="mb-2 p-2"
                    style={{ background: '#f8f9fa', borderRadius: '6px', fontSize: '0.875rem' }}
                  >
                    <div className="d-flex justify-content-between gap-2">
                      <span>{userProgress.user_name}</span>
                      <span>{taskStatusMaper[String(userProgress.status)] || 'Unknown'}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </aside>

      {/* Delete Confirmation Modal */}
      <Modal show={showDeleteModal} onHide={() => {
        setShowDeleteModal(false);
      }} centered>
        <Modal.Header closeButton>
          <Modal.Title>
            {taskData?.repeated_from_task_id ? 'Delete Repeat Task Instance' : 
             taskData?.is_repeatable ? 'Delete Repeat Task (Root)' : 'Delete Task'}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {(taskData?.repeated_from_task_id || taskData?.is_repeatable) ? (
            <>
              <p>{taskData?.repeated_from_task_id ? 'This is a repeat task instance.' : 'This is a repeat task root.'} What would you like to delete?</p>
              <div className="mt-3">
                <div className="mb-3 p-3" style={{ backgroundColor: '#f8f9fa', borderRadius: '4px', borderLeft: '4px solid #6c757d' }}>
                  <strong style={{ display: 'block', marginBottom: '5px', color: '#495057' }}>
                    {taskData?.repeated_from_task_id ? 'Delete This Instance Only' : 'Delete This Task Only'}
                  </strong>
                  <span style={{ color: '#6c757d', fontSize: '0.9em' }}>
                    {taskData?.repeated_from_task_id
                      ? 'Remove only this specific task instance.'
                      : 'Remove only this root task; the repeat series will continue from the next occurrence.'}
                  </span>
                </div>
                <div className="p-3" style={{ backgroundColor: '#fff3cd', borderRadius: '4px', borderLeft: '4px solid #ffc107' }}>
                  <strong style={{ display: 'block', marginBottom: '5px', color: '#856404' }}>Delete Entire Series</strong>
                  <span style={{ color: '#6c757d', fontSize: '0.9em' }}>Remove all instances of this repeat task, including future ones.</span>
                </div>
              </div>
            </>
          ) : (
            <p>Are you sure you want to delete this task? Once deleted, you will not be able to recover this task!</p>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button 
            className="doc-form-cancel-btn"
            onClick={() => {
              setShowDeleteModal(false);
            }}
          >
            Cancel
          </Button>
          {(taskData?.repeated_from_task_id || taskData?.is_repeatable) ? (
            <>
              <Button 
                className="doc-form-submit-btn"
                onClick={handleDeleteInstance}
              >
                {taskData?.repeated_from_task_id ? 'Delete Instance Only' : 'Delete This Task Only'}
              </Button>
              <Button 
                className="doc-form-submit-btn"
                onClick={handleDeleteSeries}
              >
                Delete Entire Series
              </Button>
            </>
          ) : (
            <Button 
              className="doc-form-submit-btn"
              onClick={handleDeleteNormal}
            >
              Delete
            </Button>
          )}
        </Modal.Footer>
      </Modal>

      {/* Edit Confirmation Modal for Repeat Task (instance and root) - same pattern as delete */}
      <Modal show={showEditModal} onHide={() => {
        setShowEditModal(false);
      }} centered>
        <Modal.Header closeButton>
          <Modal.Title>
            {taskData?.repeated_from_task_id ? 'Edit Repeat Task Instance' : 'Edit Repeat Task (Root)'}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {(taskData?.repeated_from_task_id || taskData?.is_repeatable) && (
            <>
              <p>{taskData?.repeated_from_task_id ? 'This is a repeat task instance.' : 'This is a repeat task root.'} What would you like to edit?</p>
              <div className="mt-3">
                <div className="mb-3 p-3" style={{ backgroundColor: '#f8f9fa', borderRadius: '4px', borderLeft: '4px solid #6c757d' }}>
                  <strong style={{ display: 'block', marginBottom: '5px', color: '#495057' }}>
                    {taskData?.repeated_from_task_id ? 'Edit This Instance Only' : 'Edit This Task Only'}
                  </strong>
                  <span style={{ color: '#6c757d', fontSize: '0.9em' }}>
                    {taskData?.repeated_from_task_id
                      ? 'Edit only this specific task instance.'
                      : 'Edit only this root task; changes will apply to the series definition and affect all instances.'}
                  </span>
                </div>
                <div className="p-3" style={{ backgroundColor: '#e7f3ff', borderRadius: '4px', borderLeft: '4px solid #007bff' }}>
                  <strong style={{ display: 'block', marginBottom: '5px', color: '#004085' }}>Edit Entire Series</strong>
                  <span style={{ color: '#6c757d', fontSize: '0.9em' }}>Edit the root task, which will affect all instances of this repeat task.</span>
                </div>
              </div>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button 
            className="doc-form-cancel-btn"
            onClick={() => {
              setShowEditModal(false);
            }}
          >
            Cancel
          </Button>
          {(taskData?.repeated_from_task_id || taskData?.is_repeatable) && (
            <>
              <Button 
                className="doc-form-submit-btn"
                onClick={handleEditInstance}
              >
                {taskData?.repeated_from_task_id ? 'Edit Instance Only' : 'Edit This Task Only'}
              </Button>
              <Button 
                className="doc-form-submit-btn"
                onClick={handleEditSeries}
              >
                Edit Entire Series
              </Button>
            </>
          )}
        </Modal.Footer>
      </Modal>

      {!loading && <BackToTop threshold={0} />}

      <InternalFooter />
    </React.Fragment>
  );
}

export default TaskDetails;